import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserId } from '../Login/loginSlice';
import './referalLinkButton.css'
import { copyIcon } from '../../static/svgs';

const ReferralLinkButton = () => {
    const [referralLink, setReferralLink] = useState(null);
    const userId = useSelector(selectUserId)

    const handleGenerateLink = () => {
        const link = `${process.env.REACT_APP_API_URL_CHAT}/login?ref=${userId}`;
        setReferralLink(link);
        navigator.clipboard.writeText(link);
    };

    return (
        <div>
            {referralLink ? (
                <>
                <a href={referralLink} target="_blank" rel="noopener noreferrer">
                    {referralLink}
                </a><br/>
                <label style={{color: 'black', textAlign: 'left', width: '100%'}}>Скопировано</label>
                </>
            ) : (
                <div className='ref_link_text' onClick={handleGenerateLink}>Реферальная ссылка
                <span style={{marginLeft: '10px'}}>{copyIcon}</span>
                </div>
            )}
        </div>
    );
};

export default ReferralLinkButton;
